import React from "react";
import Layout from "../components/Layout";
import styled from 'styled-components';
import bgImage from '../assets/images/keyboard-background.jpg';
import processImage from '../assets/images/process.png';

const ProcessStyles = styled.div`
  
  padding: 80px 40px 20px 40px;
  
  :before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0.125;
    background-image: url(${bgImage});
    background-repeat: repeat;
    background-position: 50% 0;
    background-size: cover;
    background-attachment: fixed;
  }

  .diagram {
    border: 2px solid black;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    max-width: 850px;
    margin: auto;
  }

  .diagram > h2 {
    text-align: center;
  }

  .diagram > img {
    max-width: 800px;
    width: 100%;
    height: auto;
    z-index: 2;
  }

  li {
    padding: 5px 0;
  }

  @media screen and (max-width: 1000px) {
    padding: 60px 20px 20px 20px;

    .diagram > p {
      font-size: 12px;
      text-align: center;
    }
  }

  @media screen and (max-width: 400px) {
    .diagram {
      padding: 0 5px;
    }

    ol {
      padding: 0 20px;
    }
  }
`;

export default function Process() {
  return <Layout>
    <ProcessStyles>
      <p>Although each project is different and is dependent on the scope, the source files provided, required deliverables and language(s), we implement a base translation process model that is part of every project.</p>
      <div className='diagram'>
        <h2>Translation Process Model</h2>
        <img src={processImage} alt='translation process diagram' />
        <p>*Translated documents or web content may be sent for client review at this state (if requested).</p>
      </div>
      <p>As an outline, we generally handle document and web localization projects this way:</p>
      <ol>
        <li>You are put in contact with one of our Project Managers (or Managers for larger, more complex projects). Your assigned Project Manager (PM) will be in liaison with your production staff in obtaining your source files for translation. The PM will assign our production team to check the file's integrity as well as any missing elements (images, fonts, etc.). Once all the files have been confirmed, they will be prepped for translation, either by converting them to a format usable for our Translation Memory tools or prepped for manual translation. As this time, upon assessment of your language pairs and subject matter, the PM will then assemble the Translation Team best suited for your project.</li>
        <li>Using the prepped files, the Translation Team will begin translation of the source documents, including glossary compilation, terminology check and consider cultural-specific rules for your target audience.</li>
        <li>Once the first draft of the translation has been checked and completed by the Translation Team, the work is sent to the Translation Quality Assurance (QA) Team. Their job is to ensure the translation is consistent and accurate and also check for issues such as punctuation, grammar and spelling. The QAed versions will be send back to the Translation Team to implement corrections or changes.</li>
        <li>Upon approval of the revised version, the text is sent to our Multilingual DTP Team (for printed documents) or our Web Team (for web localization). Their task is to ensure the target layout will match the source and adjust any cultural preference issues if needed. The formatted work is then passed on to our Multilingual DTP / Web QA Team to QA.</li>
        <li>The approved web or print layout versions are then sent back to the Translation Quality Assurance Team for final check and sign-off. Final files will be produced and compiled (if the client does not request a review on their end) and sent back to the Project Manager, ready to be delivered to the client.</li>
      </ol>
    </ProcessStyles>
  </Layout>
}
